import { render, staticRenderFns } from "./basicFieldAdmin.vue?vue&type=template&id=1ce58c9c&scoped=true&"
import script from "./basicFieldAdmin.vue?vue&type=script&lang=js&"
export * from "./basicFieldAdmin.vue?vue&type=script&lang=js&"
import style0 from "./basicFieldAdmin.vue?vue&type=style&index=0&id=1ce58c9c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce58c9c",
  null
  
)

export default component.exports